import React, { Fragment, useState } from 'react';
import {
  JaneDetailViewComponentMap,
  JaneDetailsViewActiveTabType,
} from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/JaneModal/JaneDetailsView/JaneDetailsView.types';
import {
  NavigationButton,
  NavigationButtonsWrapper,
  // JaneDetailsNavigationWrapper,
} from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/JaneModal/JaneDetailsView/JaneDetailsView.styled';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import isUserAgencySelector from 'store/selectors/userSelectors/isUserAgencySelector';
import { FetchJaneByIdByIdDataProvider } from 'components/JaneModal/FetchJaneById.data.context';
import { SelectInputPositionByDepartmentProvider } from 'components/JaneModal/views/EditJaneView/SelectInputPositionByDepartment/SelectInputPositionByDepartment.context';
import { useRemovePositionModalUIContext } from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/RemovePositionModal.ui.context';
import { Flex } from '@bookjane2/bookjane-design-library';
import { css } from 'styled-components';

export const JaneProfileComponent = () => {
  const { t } = useTranslation();
  const isUserAgency = useSelector(isUserAgencySelector);
  const b2bTabs: [string, JaneDetailsViewActiveTabType][] = [
    ['General', 'GeneralTab'],
    ['Activity', 'ActivityTab'],
  ];

  const agencyTabs: [string, JaneDetailsViewActiveTabType][] = [['General', 'GeneralTab']];

  const tabs = isUserAgency ? agencyTabs : b2bTabs;
  const [activeTab, setActiveTab] = useState<JaneDetailsViewActiveTabType>('GeneralTab');
  const ActiveTabComponent = JaneDetailViewComponentMap[activeTab];
  return (
    <Fragment>
      <Flex
        flexDirection="column"
        height="fit-content"
        minHeight="fit-content"
        css={css`
          position: sticky;
          background-color: white;
          z-index: 1;
          top: 0;
        `}
      >
        <NavigationButtonsWrapper>
          {tabs.map(([label, _enum]) => {
            return (
              <NavigationButton
                key={label}
                onClick={(e) => {
                  e.preventDefault();
                  activeTab !== _enum && setActiveTab(_enum);
                }}
                isActive={activeTab === _enum}
              >
                {t(`team_member:${label}`)}
              </NavigationButton>
            );
          })}
        </NavigationButtonsWrapper>
      </Flex>
      <ActiveTabComponent />
    </Fragment>
  );
};

export const JaneDetailsView = () => {
  const { janeId } = useRemovePositionModalUIContext();
  return (
    <SelectInputPositionByDepartmentProvider>
      <FetchJaneByIdByIdDataProvider janeId={janeId!}>
        <JaneProfileComponent />
      </FetchJaneByIdByIdDataProvider>
    </SelectInputPositionByDepartmentProvider>
  );
};
